(function() {
	'use strict';

	angular.module('claimsApp').controller('ClaimDialogController',
			ClaimDialogController);

	ClaimDialogController.$inject = [ '$scope', '$uibModalInstance' ];

	function ClaimDialogController($scope, $uibModalInstance) {
		var vm = this;

		vm.submit = function() {
			$uibModalInstance.close(true);
		}
		
		vm.cancel = function() {
			$uibModalInstance.close(false);
		}
	}
})();
